export default __webpack_public_path__ + "empty-variables-md.d80b0b6f.svg";